export * as PointOfInteractionsRouteNames from './route-name.enum';
export * as PointOfInteractionsRoutePermissions from './route-permissions.const';
